import styled, { css } from 'styled-components';

import { mediaQuery, CardContainer as UICardContainer } from '@catalyze/ui';
import { Plan } from 'features/Subscription/components/Plan';

export const cardContainerStyle = css`
    position: relative;
    align-items: center;
    ${mediaQuery(
        2,
        css`
            min-width: 33rem;
            padding: 2rem;
        `
    )}
`;

export const CardContainer = styled(UICardContainer)`
    ${cardContainerStyle}
`;

export const StyledPlan = styled(Plan)`
    &:not(:last-child) {
        margin-bottom: 1.5rem;
    }
`;

export const FormLine = styled.div`
    width: 100%;
    display: flex;
    column-gap: 1rem;
    align-items: flex-start;
`;

export const StyledFooter = styled.div`
    position: fixed;
    bottom: 0;
    right: 0;
    left: 0;
    text-align: right;
    background: lightgreen;
    border-top: 1px solid #ccc;
    padding: 1rem 3rem;
    display: flex;
    align-items: center;

    button {
        float: right;
        min-width: 100px;
        font-size: 0.9em;
    }
`;

export const StyledFooterTextContainer = styled.div`
    flex: 1.5;
    text-align: left;
    font-size: 0.9em;
`;

export const StyledButtonContainer = styled.div`
    flex: 1;
`;

export const StyledParagraph = styled.p`
    text-align: center;
    margin: 0.75rem 0;
`;

export const StyledHeader = styled.h1`
    align-self: center;
    margin-top: 1rem 0;
    font-size: 1.5rem;
`;

export const Spacer = styled.div`
    height: 1rem;
`;
